import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  text: {
    margin: theme.spacing(2),
    padding: theme.spacing(0, 1),
    fontSize: ".75rem",
    lineHeight: 1.5,
    maxWidth: 450,
    whiteSpace: "normal", // Autorise le retour à la ligne
    overflowWrap: "break-word",
    color: "#4e5d78",
  },
  link: {
    cursor: "pointer",
    textDecoration: "inherit",
    "&.hover": {
      textDecoration: "underline",
    },
    "@media (max-width: 768px)": {
      textDecoration: "underline",
    },
  },
  passwordInfo: {
    marginTop: 10,
    maxWidth: 450,
    wordBreak: "break-word",
  },
}));
